export interface HotspotProps {
  coords?: any;
  data: any;
  disabled?: boolean;
  label?: string;
  onClick: () => void;

  /** SVG props are added to the element for additional styling */
  props?: any;
}

type SpotStyles = {
  fill: string;
  strokeWidth: number;
  stroke: string;
  dash: [number, number];
  isAnimated?: boolean;
  isInverted?: boolean;
  opacity?: number;
};

export const styles: Record<string, SpotStyles> = {
  disabled: {
    fill: "rgba(255, 255, 255, 0)",
    strokeWidth: 2,
    stroke: "#aaa",
    dash: [5, 3],
    opacity: 0.5,
    isInverted: true,
  },
  normal: {
    fill: "rgba(255, 255, 255, 0)",
    strokeWidth: 2,
    stroke: "#aaa",
    dash: [5, 3],
    isInverted: true,
  },
  selected: {
    fill: "rgba(255, 255, 255, 0)",
    strokeWidth: 2,
    stroke: "#006699",
    dash: [5, 3],
    isAnimated: true,
    isInverted: true,
  },
  correct: {
    fill: "rgba(0, 255, 0, 0.4)",
    strokeWidth: 2,
    stroke: "#2fb92f",
    dash: [5, 3],
    isAnimated: true,
  },
  incorrect: {
    fill: "rgba(255, 0, 0, .4)",
    strokeWidth: 2,
    stroke: "#ba2a2a",
    dash: [5, 3],
  },
};
